import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { art } from "../state/params.svelte";

var $$_import_art = $.reactive_import(() => art);
var root = $.from_html(`<header class="svelte-27qec9kgu9fz4"><span class="wordmark svelte-27qec9kgu9fz4">eigenvisuals</span> <button class="toggle svelte-27qec9kgu9fz4"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><g stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><line x1="2.5" y1="4.5" x2="13.5" y2="4.5"></line><line x1="2.5" y1="11.5" x2="13.5" y2="11.5"></line></g><circle cx="10" cy="4.5" r="2" fill="currentColor"></circle><circle cx="6" cy="11.5" r="2" fill="currentColor"></circle></svg></button></header>`);

export default function TopBar($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var header = root();
	var button = $.sibling($.child(header), 2);

	$.reset(header);

	$.template_effect(() => {
		$.set_attribute(button, 'aria-expanded', $$_import_art().panelOpen);
		$.set_attribute(button, 'aria-label', $$_import_art().panelOpen ? "Hide controls" : "Show controls");
	});

	$.delegated('click', button, () => $$_import_art($$_import_art().panelOpen = !$$_import_art().panelOpen));
	$.append($$anchor, header);
	$.pop();
}

$.delegate(['click']);
import "bun-svelte:TopBar.svelte-2pwa0fi143f1v-style.css";